<div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="margin-top-0 margin-bottom-0">
        {{ appCopy.panelHeader['customsPaymentText'+selectedLanguage] }}
      </h4>
    </div>
    <!-- <div class="panel-body" *ngIf="!bookingDetailsAdminLoaded">
      <div class="loader-container">
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
    </div> -->
  
    <div class="panel-body">
      <h4 class="margin-top-0 margin-bottom-12">
        {{ adminBookingDetails.bookingJourneyDetails[0].bookingContact.firstName }} {{ adminBookingDetails.bookingJourneyDetails[0].bookingContact.lastName }}
      </h4>
      <ul class="list-unstyled">
        <li class="margin-bottom-8">
          <i class="icon margin-right-16">phone</i>+{{ adminBookingDetails.bookingJourneyDetails[0].bookingContact.countryCode }} {{ adminBookingDetails.bookingJourneyDetails[0].bookingContact.phoneNumber }}
        </li>
        <li>
          <i class="icon margin-right-16">message</i>{{ adminBookingDetails.bookingJourneyDetails[0].bookingContact.emailAddress }}
        </li>
      </ul>
    </div>
    <div class="panel-body">
      <app-booking-details-customs-display
        [appCopy]="appCopy"
        [selectedLanguage]= "selectedLanguage"
        [currencySymbol]="currencySymbol"
        [excessCustomsPayment]="excessCustomsPayment"
        [receiptImg]="receiptImg">
      </app-booking-details-customs-display>
    </div>
  
    <div class="panel-body">
      <form #formExcessPayment="ngForm" name="formExcessPayment" (submit)="handleExcessPaymentSubmit(formExcessPayment.value, $event)" novalidate>
  
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <input class="form-control" 
                      [ngClass]="{ 'has-error' : pspReference.invalid && pspReference.dirty }"
                      id="pspReference" 
                      name="pspReference" 
                      type="pspReference"
                      #pspReference="ngModel"
                      ngModel
                      required
                      appCheckEmpty>
              <label class="control-label" for="email">{{ appCopy.panelHeader['pspReferenceLabel'+selectedLanguage]
              }}</label>
              <p class="help-block text-danger" *ngIf="pspReference.invalid && pspReference.dirty">{{
                appCopy.panelHeader['errorPspReferenceRequired'+selectedLanguage] }}</p>
            </div>
          </div>
        </div>
  
        <button id="adminExcessPayment-submit" type="submit" class="btn btn-accent btn-lg btn-block" [disabled]="isLoading || pspReference.invalid">
          <div class="loader-container-btn" *ngIf="isLoading">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          {{ appCopy.panelHeader['confirm'+selectedLanguage] }}
        </button>
  
      </form>
    </div>
  
  </div>